import TimetableController from './Controller/TimetableController';
